import type React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import LoadingScreen from "@/components/common/LoadingScreen/LoadingScreen";

const AdminRoute: React.FC = () => {
	const { user, loading } = useAuth();
	const location = useLocation();

	if (loading) {
		return <LoadingScreen message="権限チェック中..." />;
	}

	// ユーザーのroleが'admin'であるか確認
	if (user?.role !== "admin") {
		// 管理者権限がない場合はダッシュボードにリダイレクト
		return (
			<Navigate to="/webapp/dashboard" state={{ from: location }} replace />
		);
	}

	return <Outlet />;
};

export default AdminRoute;
